require('./template.js');

Pegasus.WebTemplate = Pegasus.Template.extend({
  fragments: [],
  underscore_type: 'web_template',
  globalSettings: DS.attr('string'),
  html: DS.attr('string'),
  openingHtmlPart: DS.attr('string'),
  userDefinedBackgroundImage: null,
  userDefinedBackgroundColor: null,
  paletteType: 'WebTemplatePalette',
  bodyImageType: 'WebTemplateBodyImage',
  supportsRowColorOpacity: true,
  previewContent: function(_,value){
    if( typeof( value ) !== 'undefined' ){
      return value;
    }
    return '';
  }.property(),
  gallerySizeKey: 'large2x',
  insideHtmlPart: DS.attr('string'),
  uid: DS.attr('string'),
  maxImageWidth: 1200,
  maxContentWidth: 1024, // this is kind of strange but we use this value to calculate other things
});

Pegasus.WebTemplate.FIXTURES = [];
Pegasus.WebTemplate.reopen({
  createFromExternal: function(){
    return {
      data: {
        selectedTheme: {
          name: 'themelp1'
        }
      },
      model: this.store.createRecord(Pegasus.WebTemplate)
    };
  }
});
